import { PaginationInterface } from '@/app/shared/interfaces/response.interface';

export const BasePagination: PaginationInterface = {
  elements: 0,
  first: true,
  last: true,
  page: 1,
  size: 0,
  total_elements: 0,
  total_pages: 0,
};
